export default __webpack_public_path__ + "static/media/contact5.81429a70.jpg";